import {parseUrl} from "./parse-url.ts";

/**
 * Turns a URL into a relative URL.
 *
 * @param url The URL to turn into a relative URL.
 */
export const toRelativeUrl = (url: string): string => {
    const parsedUrl = parseUrl(url);
    return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
};
